var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral"},[_c('v-row',[_c('v-col',[_c('div',[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.$t('Referral program name:'))+" ")]),_c('router-link',{attrs:{"to":{
            name: 'referralProgram',
            query: {
              programsSearchString: _vm.referralProgramName,
            },
          },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.referralProgramName)+" ")])],1),_c('div',[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.$t('Referral program id:'))+" ")]),_vm._v(" "+_vm._s(_vm.referralProgramId)+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }